/**
 * useGuestSubSubtaskOperations — Sub-subtask operations for guest goals.
 */
import { Goal } from "@/types/todo";

export const useGuestSubSubtaskOperations = (
  goals: Goal[],
  setGoals: React.Dispatch<React.SetStateAction<Goal[]>>
) => {
  const addSubSubtask = ({ goalTitle, todoId, subtaskId, subSubtaskText }: { goalTitle: string, todoId: string, subtaskId: string, subSubtaskText: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? {
                      ...todo,
                      subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                          ? {
                              ...subtask,
                              subSubtasks: [
                                ...(subtask.subSubtasks || []),
                                { id: crypto.randomUUID(), text: subSubtaskText, completed: false },
                              ],
                            }
                          : subtask
                      ),
                    }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  const deleteSubSubtask = ({ goalTitle, todoId, subtaskId, subSubtaskId }: { goalTitle: string, todoId: string, subtaskId: string, subSubtaskId: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? {
                      ...todo,
                      subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                          ? {
                              ...subtask,
                              subSubtasks: (subtask.subSubtasks || []).filter(s => s.id !== subSubtaskId),
                            }
                          : subtask
                      ),
                    }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  const toggleSubSubtask = ({ goalTitle, todoId, subtaskId, subSubtaskId }: { goalTitle: string, todoId: string, subtaskId: string, subSubtaskId: string }) => {
    setGoals(prevGoals =>
      prevGoals.map(goal =>
        goal.title === goalTitle
          ? {
              ...goal,
              todos: goal.todos.map(todo =>
                todo.id === todoId
                  ? {
                      ...todo,
                      subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                          ? {
                              ...subtask,
                              subSubtasks: (subtask.subSubtasks || []).map(s =>
                                s.id === subSubtaskId ? { ...s, completed: !s.completed } : s
                              ),
                            }
                          : subtask
                      ),
                    }
                  : todo
              ),
            }
          : goal
      )
    );
  };

  return {
    addSubSubtask,
    deleteSubSubtask,
    toggleSubSubtask
  };
};
